import {DeleteOutlined, DollarOutlined, ShoppingCartOutlined} from "@ant-design/icons";
import {GrUserAdmin} from "react-icons/gr";
import {MdApartment, MdDashboard, MdPendingActions,} from "react-icons/md";
import {SiCodeblocks} from "react-icons/si";
import {FaFileSignature} from "react-icons/fa";

const menuItems = [
    // {
    //   type: "group",
    //   name: "CRM",
    //   children: [
    //     {
    //       key: "desktop",
    //       icon: <MdPendingActions />,
    //       link: "/main/crm/desktop",
    //       messageId: "Desktop",
    //     },
    //     {
    //       key: "call-center",
    //       icon: <GrUserAdmin />,
    //       link: "/main/crm/call-center",
    //       messageId: "Call Center",
    //     },
    //   ],
    // },
    {
        type: "group",
        name: "ERP",
        children: [
            {
                key: "all-apartments",
                icon: <MdApartment/>,
                link: "/main/all-apartments",
                messageId: "common.sidebar.chess",
                roles: ["admin", "superadmin", "finance", "manager","director"]
            },
            {
                key: "dashboard",
                icon: <MdDashboard/>,
                link: "/main/dashboard",
                messageId: "common.sidebar.dashboard",
                roles: ["admin", "superadmin", "finance","director"]
            },

            // {
            //   key: "catalogs",
            //   icon: <GrCatalogOption />,
            //   link: "/main/catalogs",
            //   messageId: "common.sidebar.catalogs",
            // },
            {
                key: "block-selector",
                icon: <SiCodeblocks/>,
                link: "/main/block-selector",
                messageId: "common.sidebar.blocks",
                roles: ["admin", "superadmin", "manager","director"]
            },
            // {
            //   key: "floor-selector",
            //   icon: <FaBuilding />,
            //   link: "/main/floor-selector",
            //   messageId: "common.sidebar.floors",
            // },
            // {
            //   key: "schema",
            //   icon: <MdOutlineSchema />,
            //   link: "/main/schema",
            //   messageId: "common.sidebar.schema",
            // },
            {
                key: "dollar-rate",
                icon: <DollarOutlined/>,
                link: "/main/dollar-rate",
                messageId: "common.sidebar.dollar_rate",
                roles: ["admin", "superadmin", "finance","director"]
            },
            {
                key: "orders",
                icon: <ShoppingCartOutlined/>,
                link: "/main/orders",
                messageId: "common.sidebar.orders",
                roles: ["admin", "superadmin", "finance", "manager","director"]
            },
            {
                key: "delete-orders",
                icon: <DeleteOutlined/>,
                link: "/main/delete-orders",
                messageId: "common.sidebar.delete_orders",
                roles: ["admin", "superadmin", "director"]
            },
        ],
    },
    {
        type: "group",
        name: "Admin",
        children: [
            {
                key: "user",
                icon: <GrUserAdmin/>,
                link: "/main/table?pageId=user",
                messageId: "common.sidebar.users",
                roles: ["admin", "superadmin"]
            },
            {
                key: "signatory",
                icon: <FaFileSignature/>,
                link: "/main/signatory",
                messageId: "common.sidebar.signatory",
                roles: ["admin", "superadmin"]
            },
            {
                key: "action",
                icon: <MdPendingActions/>,
                link: "/main/table?pageId=action",
                messageId: "common.sidebar.log",
                roles: [ "superadmin"]
            },
        ],
    },
];

export default menuItems;
